import React from 'react';
import DataSourceConfiguration from './DataSourceConfiguration';

interface BulatConfigurationProps {
    configuration: {
        // IDataSourceConfiguration Members
        SourceType?: string;
        Configuration?: string;
    };
    onChange: (field: string, value: string | number | boolean) => void;
    disabled?: boolean;
}

interface BulatConfigurationComponent extends React.FC<BulatConfigurationProps> {
    configFields: string[];
}

const BulatConfiguration: BulatConfigurationComponent = ({
    configuration,
    onChange,
    disabled = false
}) => {
    return (
        <React.Fragment>
            <DataSourceConfiguration 
                configuration={{
                    SourceType: configuration.SourceType || '',
                    Configuration: configuration.Configuration || '{}'
                }}
                onChange={onChange}
                disabled={disabled}
            />
        </React.Fragment>
    );
};

// Define the configuration fields used by this supplier
BulatConfiguration.configFields = [
    'SourceType',
    'Configuration'
];

export default BulatConfiguration;
